import { memo, MouseEvent } from 'react';
import { UmbracoTypes } from '~/lib/data-contract';
import { StyledNavigationItem } from './styled';

type Props = {
    link?: UmbracoTypes.ILink;
    subNodes?: UmbracoTypes.INavigationNode[];
    isActive?: boolean;
    isOpen?: boolean;
    onClick?: (event: MouseEvent) => void;
};

/**
 * Navigation item, which will render either as a link or button, based on it's childnodes presence.
 * has a active and inactive state.
 */
export const NavigationItem = memo(function Render(props: Props) {
    const { link, subNodes, onClick, isOpen: _isOpen, ...rest } = props;

    if (subNodes?.length) {
        return (
            <StyledNavigationItem
                href={link?.url || '/'}
                prefetch={false}
                onClick={onClick}
                aria-expanded={props.isActive}
                data-content={link?.text}
                {...rest}
            >
                {link?.text}
            </StyledNavigationItem>
        );
    }

    if (link?.url) {
        return (
            <StyledNavigationItem
                href={link.url}
                prefetch={false}
                data-content={link?.text}
                target={link.target}
                title={link.title}
                {...rest}
            >
                {link.text}
            </StyledNavigationItem>
        );
    }

    return <></>;
});
